import { Amplify } from 'aws-amplify';

const region           = import.meta.env.VITE_REGION          ?? 'us-east-1';
const userPoolId       = import.meta.env.VITE_USER_POOL_ID    as string;
const userPoolClientId = import.meta.env.VITE_USER_POOL_CLIENT_ID as string;
const apiUrl           = import.meta.env.VITE_API_URL          as string;

Amplify.configure({
  Auth: {
    Cognito: {
      // region is inferred from the user pool ID (us-east-1_...)
      userPoolId,
      userPoolClientId,
      loginWith: {
        email: true,
      },
      signUpVerificationMethod: 'code' as const,
      userAttributes: {
        email: { required: true },
        name:  { required: true },
      },
      passwordFormat: {
        minLength: 8,
        requireLowercase: true,
        requireUppercase: true,
        requireNumbers: true,
        requireSpecialCharacters: false,
      },
    },
  },
});

export const awsConfig = { region, userPoolId, userPoolClientId, apiUrl };
export default awsConfig;
